import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import SlotPicker from "./SlotPicker";
import styles from "./style.module.scss";

/** One week of open times with previous / next week buttons. load({from, days}) returns {slots}. */
const WeekSlots = ({ load, tz, selected, onPick, t, locale, reloadKey }) => {
  const [from, setFrom] = useState(dayjs().startOf("day"));
  const [slots, setSlots] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setSlots(null);
    setFailed(false);
    load({ from: from.format("YYYY-MM-DD"), days: 7 })
      .then((res) => !cancelled && setSlots(res.slots || []))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [from, load, reloadKey]);

  const atStart = !from.isAfter(dayjs().startOf("day"));
  return (
    <div>
      <div className={styles.weekNav}>
        <Button icon={<LeftOutlined />} disabled={atStart} onClick={() => setFrom(from.subtract(7, "day"))} aria-label={t("sonic_calendar.public_prev_week")} />
        <span>
          {from.format("D MMM")} – {from.add(6, "day").format("D MMM")}
        </span>
        <Button icon={<RightOutlined />} onClick={() => setFrom(from.add(7, "day"))} aria-label={t("sonic_calendar.public_next_week")} />
      </div>
      {failed ? <p className={styles.empty}>{t("sonic_calendar.public_error")}</p> : null}
      {slots === null && !failed ? <Spin /> : null}
      {slots ? (
        <SlotPicker slots={slots} tz={tz} selected={selected} onPick={onPick} locale={locale} emptyText={t("sonic_calendar.public_no_slots_week")} />
      ) : null}
    </div>
  );
};

export default WeekSlots;
